<template>
    <nav-bar>
        <router-link :to="{name: route.name}" class="sah-nav-item__link" v-for="route in routes" :key="route.name">
            <nav-item>
                <template #text>
                    {{ $tc(`navigation.${route.name}`) }}
                </template>
                <template #icon>
                    <img :src="require(`../assets/images/nav-${route.name}.svg`)" />
                </template>
            </nav-item>
        </router-link>
    </nav-bar>
</template>

<script>
import {NavBar, NavItem} from "atom";
/**
 *
 * @vue-prop {String} message - greetings message
 */
export default {
    name: "navigation-bar",
    components: {
        "nav-bar": NavBar,
        "nav-item": NavItem,
    },
    computed: {
        routes() {
            return this.$router.options.routes.filter(element => element.isNavItem);
        },
    },
};
</script>
